// extracted by mini-css-extract-plugin
module.exports = {"files":"Files_files__3CBP4","uploadedFile":"Files_uploadedFile__1t9FQ","fileName":"Files_fileName__2pnUC","deleteFile":"Files_deleteFile__2J9Se"};